import { memoryQuery } from '../memory/memoryQuery';

export type CopilotStep = {
    id: string;
    label: string;
    description: string;
    intent: string;
    estimatedDuration: number; // minutes
    order: number;
    recommendedVenue?: string; // Phase 12: Learned recommendation
};

export type CopilotPlan = {
    id: string;
    title: string;
    steps: CopilotStep[];
    currentStepIndex: number;
};

export const copilotPlanner = {
    createPlan(intent: string, query: string): CopilotPlan {
        console.group(`%c[Copilot] Creating spatial plan for: ${intent}`, 'color: #3b82f6; font-weight: bold;');
        
        const planId = `PLAN-${Date.now()}`;
        let steps: CopilotStep[] = [];

        // Planning logic with memory enrichment
        if (query.toLowerCase().includes("night") || query.toLowerCase().includes("itinerary")) {
            const rooftopRec = memoryQuery.getRecommendationsForIntent("rooftop")[0]?.label;
            const restaurantRec = memoryQuery.getRecommendationsForIntent("restaurant")[0]?.label;

            steps = [
                { id: "s1", order: 1, label: "Rooftop Drinks", description: "City views.", intent: "rooftop", estimatedDuration: 60, recommendedVenue: rooftopRec },
                { id: "s2", order: 2, label: "Fine Dining", description: "Top-rated dinner.", intent: "restaurant", estimatedDuration: 120, recommendedVenue: restaurantRec },
                { id: "s3", order: 3, label: "Lounge", description: "Nightlife transition.", intent: "nightlife", estimatedDuration: 90 }
            ];
        } else {
            const genericRec = memoryQuery.getRecommendationsForIntent(intent)[0]?.label;
            steps = [
                { id: "s1", order: 1, label: `Explore ${intent}`, description: `Find ${intent} sources.`, intent: intent, estimatedDuration: 30, recommendedVenue: genericRec }
            ];
        }

        console.info(`Plan generated with ${steps.length} steps.`);
        console.groupEnd();

        return {
            id: planId,
            title: steps.length > 1 ? "Nightlife Itinerary" : `Exploration: ${intent}`,
            currentStepIndex: 0,
            steps
        };
    }
};
